import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const slides = ['/assets/img1.webp', '/assets/img2.webp', '/assets/img3.webp', '/assets/img4.webp', '/assets/img5.webp'];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 10000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const scrollToContent = () => {
    const content = document.getElementById('main-content');
    if (content) content.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header className="hero">
      <div className="slider-container">
        <div 
          className="slider-wrapper" 
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {slides.map((img, index) => (
            <div key={index} className="slide-item">
              <div 
                className="slide" 
                style={{ backgroundImage: `url(${img})` }} 
              />
            </div>
          ))}
        </div>

        <div className="hero-content">
          <h1 id="title-vix">VIX1ON</h1>
          <button className="btn-main" onClick={scrollToContent}>
            Get Started!
          </button>
        </div>

        {/* Tombol panah kanan-kiri dihapus dari sini */}

        <div className="dots-container">
          {slides.map((_, index) => (
            <span 
              key={index} 
              className={`dot ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </div>
      </div>
    </header>
  );
};

export default Hero;